import React from 'react'
import './Transaction.css'
const d = new Date();

const toIndianCurrency = (num) => {
  const curr = num.toLocaleString('en-IN', {
     style: 'currency',
     currency: 'INR'
  });
  return curr;
};

export const Transaction = ({transaction, onDelete}) => {
  return (
    <div id="transaction" style={{ borderRight:"5px solid", borderRightColor: transaction.ttype==='Credit'?'green':'red', 
    backgroundColor: transaction.ttype==='Credit'?'rgb(196, 255, 196)':'rgb(253, 206, 206)'
    }}>
      <div id="sec1">
        <h4 style={{paddingBottom : '5%',}}>Sender: {transaction.sender}</h4>
        <h4>Receiver: {transaction.receiver}</h4>
      </div>
      <div id="sec2">
        <h3>Amount</h3><br></br>
        {transaction.ttype==='Credit'?<h4 style={{color:'green'}}>{toIndianCurrency(parseInt(transaction.amount))}</h4>:<h4 style={{color:'red',}}>{toIndianCurrency(parseInt(transaction.amount))}</h4>}
        <h3></h3>
      </div>
      <div id="sec3">
        <h3>Transaction Type</h3><br></br>
        {transaction.ttype==='Credit'?<h3 style={{color:'green'}}>Credited</h3>:<h3 style={{color:'red'}}>Debited</h3>}
      </div>
      <div id="sec4">
        <h4 style={{paddingBottom : '3%',}}>Date: {transaction.date}</h4>
        <h4 style={{paddingBottom : '3%',}}>Time: {transaction.time}</h4>
        <h4>Description: {transaction.desc}</h4>
      </div>
      <button onClick={()=>{onDelete(transaction)}}><img src="cancel.png" id="image"></img></button>
    </div>
  )
}
